const Backbone = require('backbone');
const format = require('format');
const dustjs = require('dustjs');

require('store/global/common/_default_price_box_sqft.dust');
require('store/global/common/_default_price_box_by_packaging.dust');

const _salePriceBox = require('store/global/common/_sale_price_box.dust');
const _sqftPriceBox = require('store/global/common/_sqft_price_box.dust');
const _proSavingsPriceBox = require('store/global/common/_pro_savings_price_box.dust');

/**
 * NOTE: the model for this view is actually the product model.
 * Do not set any attributes on this model as it will have adverse affects
 * on the rest of the modules
 */
module.exports = Backbone.View.extend({
	el: '.item-price .js-price',

	initialize: function() {
		this.listenTo(Backbone, 'finish:hover', this._render.bind(this));
		this.listenTo(Backbone, 'finish:clicked', this._render.bind(this));
		this.listenTo(Backbone, 'price:updated', this._updateRecomendedOptionsPrice.bind(this));
		this.listenTo(Backbone, 'recommendedOptionFinish:clicked', this._updateRecomendedOptionsPrice.bind(this));
		this.listenTo(Backbone, 'body:click', this._bodyClick.bind(this));
		this.$el.popover({ selector: '[data-toggle=popover]' });
	},

	_bodyClick: function(e) {
		// Hide popover on click outside of toggle or popover itself.
		if ($(e.target).closest('.popover, [data-toggle=popover]').length === 0) {
			this.$el.find('[data-toggle=popover]').popover('hide');
		}
	},

	_updateRecomendedOptionsPrice: function() {
		this.renderRecommendedOptionsPrice(this.model.getCurrentPrice());
	},

	/**
	 * Renders price display for purchase box and for configure options price
	 * @param  {Object} data Finish data
	 */
	_render: function(data) {
		const price = data.priceValue || data.price;
		const configureOptionsPrice = data.isDefault
			? data.price
			: this._formatPriceForDisplay(price + this.model.optionGroups.getSelectedOptionsPrice());
		this.renderPurchaseBoxPrice(price, data);
		if (window.dataLayer.hasRecommendedOption || this._hasOptions()) {
			this.renderRecommendedOptionsPrice(configureOptionsPrice);
		}
	},

	/**
	 * Returns true if product has options that either required options or priced options to configure the product when purchasing,
	 * false otherwise. This validation doesn't include having "Recommended Options".
	 * @returns {boolean}
	 */
	_hasOptions: function() {
		return Boolean(window.dataLayer.hasRequiredOptions || window.dataLayer.hasPricedOptions);
	},

	/**
	 * Formats the price for display.
	 * @param {number|string} price - the price to be formatted.
	 * @return {String} The price, formatted for display.
	 */
	_formatPriceForDisplay: function(price) {
		if (!price) {
			return 'Discontinued';
		}

		// Convert string prices back to floats for formatting as currency. If we don't end up with a good
		// value, return the raw price argument instead.
		const numericPrice = typeof price === 'string' ? parseFloat(price.replace(/[^0-9.]/g, '')) : price;
		let formattedPrice = isNaN(numericPrice) ? price : format.currency(numericPrice);
		if (typeof formattedPrice === 'undefined') {
			formattedPrice = price;
		}
		return formattedPrice;
	},

	/**
	 * Updates price in the product page purchase box.
	 * @param  {number|string} price
	 * @param  {object} data
	 */
	renderPurchaseBoxPrice: function(price, data) {
		if (!price) {
			this.updatePurchaseBoxPrice('Discontinued');
			return;
		}

		const discount = data.discount;
		const numericPrice = typeof price === 'string' ? parseFloat(price.replace(/[^0-9.]/g, '')) : price;

		if (this.model.hasSquareFootage()) {
			const squareFeetPerCarton = this.model.getSquareFeetPerCarton();
			const pricePerSquareFoot = numericPrice / squareFeetPerCarton;
			const hideSquareFeetPerCarton = window.dataLayer.isPla && window.dataLayer.dustData.viewPrefix === 'mobile';
			dustjs.render(
				_sqftPriceBox,
				{
					pricePerSquareFoot,
					squareFeetPerCarton,
					lowPrice: numericPrice,
					hideSquareFeetPerCarton,
					pricebookTooltip: data.pricebookTooltip
				},
				(err, markup) => this.updatePurchaseBoxPrice(markup)
			);
		} else if (this.model.hasPricingByUOM()) {
			this.updatePricingByUOM({ ...this.model.getPricingByUOM(data), pricebookTooltip: data.pricebookTooltip });
		} else if (window.dataLayer.customer.isPro && window.dataLayer.enableSalePricing && discount && discount.showWasPrice) {
			const consumerPrice = this._formatPriceForDisplay(discount.wasPrice);
			const discountText = discount.wasSavings;
			const showWasPrice = true;
			const expDate = discount.expDate;
			const proPrice = this._formatPriceForDisplay(price);
			const proParticipationDiscountSameAsConsumer = window.dataLayer.proParticipationDiscountSameAsConsumer;

			dustjs.render(
				_proSavingsPriceBox,
				{
					proPrice,
					consumerPrice,
					discountText,
					showWasPrice,
					expDate,
					proParticipationDiscountSameAsConsumer,
					pricebookTooltip: data.pricebookTooltip
				},
				(err, markup) => this.updatePurchaseBoxPrice(markup)
			);
		} else if (window.dataLayer.abPdpProSavingsEnabled && window.dataLayer.customer.isPro && data.proSavings) {
			const consumerPrice = this._formatPriceForDisplay(data.consumerPrice);
			const discountText = `${data.proSavings.percentOff}%`;
			const proPrice = this._formatPriceForDisplay(price);
			dustjs.render(
				_proSavingsPriceBox,
				{
					proPrice,
					consumerPrice,
					discountText,
					pricebookTooltip: data.pricebookTooltip
				},
				(err, markup) => this.updatePurchaseBoxPrice(markup)
			);
		} else if (window.dataLayer.enableSalePricing) {
			this.renderSalePriceBox(price, data);
		} else {
			this.updatePurchaseBoxPrice(this._formatPriceForDisplay(price));
		}
	},

	updatePricingByUOM: function(model) {
		if (model.hasPricingByUOM) {
			dustjs.render(_sqftPriceBox, model, this.updatePrice.bind(this));
		}
		return this;
	},

	updatePrice: function(err, markup) {
		err ? window.clientErrorHandler(err) : this.$el.not('.js-recommended-options-price').html(markup);
		return this;
	},

	updatePurchaseBoxPrice: function(markup) {
		// Remove existing popover before updating markup.
		this.$el.find('[data-toggle=popover]').popover('destroy');
		this.$el.not('.js-recommended-options-price').html(markup);
	},

	renderSalePriceBox: function(price, data) {
		const basePrice = data.basePrice;
		const formattedBasePrice = basePrice ? this._formatPriceForDisplay(basePrice) : null;
		const formattedPrice = this._formatPriceForDisplay(price);
		dustjs.render(
			_salePriceBox,
			{
				price: formattedPrice,
				basePrice: formattedBasePrice,
				discount: data.discount,
				pricebookTooltip: data.pricebookTooltip
			},
			(err, markup) => this.updatePurchaseBoxPrice(markup)
		);
	},

	/**
	 * Updates price in the configure options box and purchase price box.
	 * @param  {number} price
	 */
	renderRecommendedOptionsPrice: function(price) {
		const formattedPrice = this._formatPriceForDisplay(price);
		window.dataLayer.isConfigurePage
			? this.updatePurchaseBoxPrice(formattedPrice)
			: this.$el.closest('.js-recommended-options-price').html(formattedPrice);
		return this;
	}
});
